import React from 'react';
import {
    Slider,
    Typography,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
    FormControlLabel,
    Paper, IconButton, CircularProgress
} from '@material-ui/core';



import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import withShipment from "../../withShipment";
import { userInfoSelector, usersSelector } from "../../redux/selectors/auth";
import { getUsers } from "../../redux/actions/auth";

import "./Todo.css";
import CustomToolbar from "../global/CustomToolbar";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import axios from "axios";
import {BASE_URL} from "../global/Server/endpoints";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import {Autocomplete} from "@material-ui/lab";
import {quillModules, statusOptions, priorityOptions, getStatusFromProgress} from "./constants";

import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import EditIcon from "@material-ui/icons/Edit";
import {SwipeableTaskCard} from "./SwipeableTaskCard";
import {Box} from "@mui/material";

class Todo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      todos: [],
      newTodo: {
        title: '',
        description: '',
        dueDate: new Date(),
        assignedTo: '',
        priority: 'Medium',
        status: 'Not Started',
        progress: 0,
        deliverables: [],
        companyId: this.props.userInfo.companyId
      },
      openDialog: false,
      editingTodo: null,

      // feedback bar states
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',

      filters: {
        status: "ALL",
        priority: "ALL",
        myTask: false,
        overdue: false,
      }

    };
  }

  async componentDidMount() {
    this.props.getUsers();
    await this.fetchTodos()
  }

  /* ---------------- Feedback Bar ------------------- */

  openFeedbackBar = (status,message) => {
    this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
  }

   closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
    })
  }

  /* ------------------ API Calls -------------------- */
  fetchTodos = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
          `${BASE_URL}/todo/list`,
          { companyId: this.props.userInfo.companyId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );

      // Map API response to UI-friendly structure
      const todos = (res.data.todos || []).map(todo => {
        const assignedUser = this.props.allUsers.find(u => u.userId === todo.assignedTo);
          const createdBy = this.props.allUsers.find(u => u.userId === todo.createdBy);

        return {
            id: todo.todoId, // use string ID
            title: todo.title,
            description: todo.description,
            dueDate: new Date(todo.dueDate),
            status: todo.status,
            priority: todo.priority,
            progress: todo.progress || 0,
            owner: createdBy ? `${createdBy.firstname} ${createdBy.lastname}` : "Unknown",
            assignees: assignedUser ? [`${assignedUser.firstname} ${assignedUser.lastname}`] : [],
            assignedTo: todo.assignedTo,
            createdBy: todo.createdBy,
            color:
                todo.priority === "Critical"
                    ? "red"
                    : todo.priority === "High"
                        ? "orange"
                        : todo.priority === "Medium"
                            ? "blue"
                            : todo.priority === "Low"
                                ? "gray"
                                : "gray", // fallback
        };
      });

      this.setState({ todos });
    } catch (e) {
      this.openFeedbackBar("error", "Failed to load tasks");
    }
  };

    isOwner = (todo) => {
        return todo?.createdBy === this.props.userInfo.userId;
    };

    handleProgressChange = (value) => {
        const status = getStatusFromProgress(value);

        this.setState(prev => ({
            newTodo: {
                ...prev.newTodo,
                progress: value,
                status
            }
        }));
    };

  createTodo = async () => {
    const { newTodo, editingTodo } = this.state;
    const token = localStorage.getItem("token");

    if (!newTodo.title || !newTodo.assignedTo) {
      this.openFeedbackBar("error", "Title and Assigned User are required");
      return;
    }

    try {
      const url = editingTodo ? `${BASE_URL}/todo/update` : `${BASE_URL}/todo/save`;
      const payload = editingTodo ? { ...newTodo, todoId: editingTodo.todoId } : newTodo;

      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
      });

      if (res.data.success) {
        this.openFeedbackBar("success", res.data.message);
        this.fetchTodos();
      } else {
        this.openFeedbackBar("error", res.data.message);
      }
    } catch (e) {
      this.openFeedbackBar("error", e.response?.data?.message || "Error saving task");
    }
  };

  updateStatus = async (todoId, newStatus) => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/todo/updateStatus`,
        {todoId: todoId, status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      this.openFeedbackBar("success", res.data.message);
      this.fetchTodos();
    } catch (e) {
      this.openFeedbackBar("error", "Failed to change status");
    }
  };

  deleteTodo = async (todoId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${BASE_URL}/todo/delete`,
        { todoId: todoId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      this.openFeedbackBar("success", res.data.message);
      this.fetchTodos();
    } catch (e) {
      this.openFeedbackBar("error", "Failed to delete task");
    }
  };

  /* --------------------------------------------------*/

  handleInputChange = (field, value) => {
    this.setState(prev => ({
      newTodo: { ...prev.newTodo, [field]: value }
    }));
  };


  openDialog = (todo = null) => {
    if (todo) {
        const isOwner = todo.createdBy === this.props.userInfo.userId;
        this.setState({
            editingTodo: { ...todo, isOwner },
            newTodo: { ...todo, dueDate: new Date(todo.dueDate) },
            openDialog: true,
        });

      // this.setState({ editingTodo: todo, newTodo: { ...todo, dueDate: new Date(todo.dueDate) }, openDialog: true });
    } else {
      this.setState({ editingTodo: null,
          newTodo: {
               title: '',
              description: '',
              dueDate: new Date(),
              assignedTo: '',
              companyId: this.props.userInfo.companyId },
          openDialog: true
      });
    }
  };
  closeDialog = () => this.setState({ openDialog: false });

  toggleExpand = (id) => {
    this.setState(prev => ({
      expandedId: prev.expandedId === id ? null : id
    }));
  };


  render() {
    const { todos, newTodo } = this.state;
    const { allUsers, userInfo } = this.props;

      const isEditing = Boolean(this.state.editingTodo);
      const isOwner = this.state.editingTodo?.isOwner ?? true;

    const headerButtons = [{ icon: <AddCircleIcon />, handler: this.openDialog, title: "Add Task" }]

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>

          <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
        />

        <CustomToolbar title="Tasks" createTitle="Task" backTitle="Back To Menu" headerButtons={headerButtons} />

        {/* Create Task Modal */}
        <Dialog open={this.state.openDialog} onClose={this.closeDialog} fullWidth maxWidth="lg">
          <DialogTitle> {this.state.editingTodo ? "Update Task": "Create New Task"}</DialogTitle>

         <DialogContent>
           <TextField
               variant="outlined"
               label="Title"
               value={newTodo.title}
               disabled={isEditing && !isOwner}
               onChange={e => this.handleInputChange('title', e.target.value)}
               fullWidth
               style={{ marginBottom: 16 }}
           />

          <Autocomplete
              options={allUsers}
              disabled={isEditing && !isOwner}
            getOptionLabel={option => [option.firstname, option.lastname].filter(Boolean).join(' ')}
            autoHighlight
            disableClearable
            value={allUsers.find(user => user.userId === newTodo.assignedTo) || null}
            onChange={(event, newValue) => this.handleInputChange('assignedTo', newValue?.userId || '')}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assign To"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                style={{ marginBottom: 16,marginTop: 16 }}
              />
            )}
          />

           <Autocomplete
               options={priorityOptions}
               disabled={isEditing && !isOwner}
               getOptionLabel={(option) => option.label}
               value={priorityOptions.find(opt => opt.label === newTodo.priority) || null}
               onChange={(event, newValue) =>
                   this.handleInputChange('priority', newValue?.label || '')
               }
               renderInput={(params) => (
                   <TextField
                       {...params}
                       label="Priority"
                       variant="outlined"
                       fullWidth
                       style={{ marginTop: 16 }}
                       InputProps={{
                         ...params.InputProps,
                         startAdornment: newTodo.priority ? (
                             <div
                                 style={{
                                   width: 16, // circle diameter
                                   height: 16,
                                   borderRadius: '50%', // makes it round
                                   backgroundColor: priorityOptions.find(o => o.label === newTodo.priority)?.color || '#ccc',
                                   display: 'inline-block',
                                   marginRight: 8,
                                   verticalAlign: 'middle',
                                 }}
                             />
                         ) : null,
                       }}
                   />
               )}
           />

             <Box
                 className="progress-container"
             >

                 {/* Slider + Status */}
                 <Box flex={1}>
                     <Typography variant="subtitle2" gutterBottom>
                         Progress
                     </Typography>

                     <Slider
                         value={newTodo.progress}
                         min={0}
                         max={100}
                         step={1}
                         onChange={(e, value) => this.handleProgressChange(value)}
                     />

                 </Box>

                 {/* Circular Progress */}
                 <Box position="relative" display="inline-flex">
                     <CircularProgress
                         variant="determinate"
                         value={newTodo.progress}
                         size={80}
                         thickness={4}
                         color={
                             newTodo.progress === 100
                                 ? "secondary"
                                 : newTodo.progress > 0
                                     ? "primary"
                                     : "inherit"
                         }
                     />
                     <Box
                         top={0}
                         left={0}
                         bottom={0}
                         right={0}
                         position="absolute"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                     >
                         <Typography variant="h6">
                             {newTodo.progress}%
                         </Typography>
                     </Box>
                 </Box>

             </Box>


           <Autocomplete
               options={statusOptions}
               disabled={isEditing && !isOwner}
               getOptionLabel={(option) => option.label}
               value={statusOptions.find(opt => opt.label === newTodo.status) || null}
               onChange={(event, newValue) =>
                   this.handleInputChange('status', newValue?.label || '')
               }
               renderInput={(params) => (
                   <TextField
                       {...params}
                       label="Status"
                       variant="outlined"
                       fullWidth
                       style={{ marginTop: 16 }}
                       InputProps={{
                         ...params.InputProps,
                         startAdornment: newTodo.status ? (
                             <div
                                 style={{
                                   width: 16, // circle diameter
                                   height: 16,
                                   borderRadius: '50%', // makes it round
                                   backgroundColor: statusOptions.find(o => o.label === newTodo.status)?.color || '#ccc',
                                   display: 'inline-block',
                                   marginRight: 8,
                                   verticalAlign: 'middle',
                                 }}
                             />
                         ) : null,
                       }}
                   />
               )}
           />



          <KeyboardDatePicker
              disabled={isEditing && !isOwner}
            margin="normal"
            label="Due Date"
            format="MM/dd/yyyy"
            value={newTodo.dueDate}
            onChange={date => this.handleInputChange('dueDate', date)}
            fullWidth
            inputVariant="outlined"
          />

           <div style={{ marginTop: 16 }}>

               <ReactQuill
                   readOnly={isEditing && !isOwner}
                   theme="snow"
                   value={newTodo.description}
                   modules={quillModules}
                   onChange={(value) =>
                       this.handleInputChange("description", value)
                   }
                   placeholder="Add details, bullet points, links…"
               />
           </div>
        </DialogContent>

          <DialogActions>
            <Button onClick={this.closeDialog}>Cancel</Button>
            <Button color="primary" variant="contained" onClick={() => { this.createTodo(); this.closeDialog(); }}> {this.state.editingTodo ? "Update Task" : "Add Task"}</Button>
          </DialogActions>
        </Dialog>

          <div className="root">

          <Paper elevation={0} className="filters-bar" style={{ padding: 16 }}>
              <div
                  className="filters-left"
                  style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 16,
                  }}
              >
                  {/* First Row: Status + Priority */}

                  <Autocomplete
                      options={priorityOptions}
                      getOptionLabel={(option) => option.label}
                      value={priorityOptions.find(opt => opt.label === this.state.filters.priority) || null}
                      onChange={(e, newValue) =>
                          this.setState({ filters: { ...this.state.filters, priority: newValue?.label || "ALL" } })
                      }
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              label="Priority"
                              variant="outlined"
                              style={{ minWidth: 120 }}
                              InputProps={{
                                  ...params.InputProps,
                                  startAdornment: this.state.filters.priority !== "ALL" ? (
                                      <div
                                          style={{
                                              width: 16,
                                              height: 16,
                                              borderRadius: "50%",
                                              backgroundColor:
                                                  priorityOptions.find(o => o.label === this.state.filters.priority)?.color ||
                                                  "#ccc",
                                              display: "inline-block",
                                              marginRight: 8,
                                              verticalAlign: "middle",
                                          }}
                                      />
                                  ) : null,
                              }}
                          />
                      )}
                  />

                  <Autocomplete
                      options={statusOptions}
                      getOptionLabel={(option) => option.label}
                      value={statusOptions.find(opt => opt.label === this.state.filters.status) || null}
                      onChange={(e, newValue) =>
                          this.setState({ filters: { ...this.state.filters, status: newValue?.label || "ALL" } })
                      }
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              label="Status"
                              variant="outlined"
                              style={{ minWidth: 120 }}
                              InputProps={{
                                  ...params.InputProps,
                                  startAdornment: this.state.filters.status !== "ALL" ? (
                                      <div
                                          style={{
                                              width: 16,
                                              height: 16,
                                              borderRadius: "50%",
                                              backgroundColor:
                                                  statusOptions.find(o => o.label === this.state.filters.status)?.color ||
                                                  "#ccc",
                                              display: "inline-block",
                                              marginRight: 8,
                                              verticalAlign: "middle",
                                          }}
                                      />
                                  ) : null,
                              }}
                          />
                      )}
                  />



                  {/* Second Row: My Tasks + Overdue */}
                  <div
                      style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 16,
                          width: "100%",
                          marginTop: 8,
                      }}
                  >
                      <FormControlLabel
                          control={
                              <Checkbox
                                  color="primary"
                                  checked={this.state.filters.myTask}
                                  onChange={(e) =>
                                      this.setState({
                                          filters: { ...this.state.filters, myTask: e.target.checked },
                                      })
                                  }
                              />
                          }
                          label="My Tasks"
                      />

                      <FormControlLabel
                          control={
                              <Checkbox
                                  color="primary"
                                  checked={this.state.filters.overdue}
                                  onChange={(e) =>
                                      this.setState({
                                          filters: { ...this.state.filters, overdue: e.target.checked },
                                      })
                                  }
                              />
                          }
                          label="Overdue"
                      />
                  </div>
              </div>
          </Paper>



        {todos
            .filter(task => {
              const { status, priority, myTask, overdue } = this.state.filters;

              if (status !== "ALL" && task.status !== status) return false;
              if (priority !== "ALL" && task.priority !== priority) return false;

                if (myTask) {
                    const myFullName = `${userInfo.firstname} ${userInfo.lastname}`;
                    if (!task.assignees.includes(myFullName)) return false;
                }

                if (overdue) {
                    const today = new Date();
                    today.setHours(0,0,0,0);
                    const due = new Date(task.dueDate);
                    due.setHours(0,0,0,0);

                    if (due.getTime() >= today.getTime()) return false; // not overdue
                }

              return true;
            })
            .map(task => {
                const expanded = this.state.expandedId === task.id;

                return (
                    <SwipeableTaskCard
                        key={task.id}
                        task={task}
                        canDelete={task.createdBy === userInfo.userId}
                        onDelete={(id) => this.deleteTodo(id)}
                        onClick={() => this.toggleExpand(task.id)}
                    >

                    <div className={`task-card ${expanded ? "expanded" : ""}`}>
                      {/* LEFT COLOR BAR */}
                      <div
                          className="left-bar"
                          style={{ backgroundColor: task.color }}
                      />

                      <div className="task-body">

                        {/* Edit */}
                        <div className="task-actions">
                          <IconButton
                              color="primary"
                              onClick={(e) => { e.stopPropagation(); this.openDialog(task); }}
                          >
                            <EditIcon />
                          </IconButton>
                        </div>

                        {/* HEADER */}
                        <div className="task-header">
                          <div className="title-row">


                          <span
                              className="status-dot"
                              style={{ backgroundColor: task.color }}
                          />
                            <Typography className="task-title">
                              {task.title}
                            </Typography>
                          </div>

                          <Typography className="due">
                              Due {task.dueDate.toLocaleDateString()}
                          </Typography>
                        </div>

                        {/* COLLAPSED VIEW */}
                        {!expanded && (
                            <div className="collapsed-row">

                              <div className="left-meta">
                                <span className={`status-pill ${task.status.replace(" ", "-")}`}>
                                  {task.status}
                                </span>

                                <div className="avatars">
                                  {task.assignees.map((a, i) => (
                                      <div key={i} className="avatar">{a[0]}</div>
                                  ))}
                                </div>
                              </div>

                            </div>
                        )}

                        {/* EXPANDED VIEW */}
                        {expanded && (
                            <>
                              <div className="expanded-tags">
                                {task.priority === "Critical" && (
                                    <span className="priority-pill">Critical</span>
                                )}
                                <span className={`status-pill ${task.status.replace(" ", "-")}`}>
                                  {task.status}
                                </span>

                                <div className="progress">
                                  <div className="progress-bg">
                                    <div
                                        className="progress-fill"
                                        style={{ width: `${task.progress}%` }}
                                    />
                                  </div>
                                  <span>{task.progress}%</span>
                                </div>
                              </div>


                              <div className="people-row">
                                <span className="people-item">
                                  <AssignmentTurnedInIcon className="people-icon" />
                                  <b>{task.owner}</b>
                                </span>

                                                        <span className="people-item">
                                  <PeopleOutlineIcon className="people-icon" />
                                                          {task.assignees.join(", ")}
                                </span>
                              </div>

                              {task.description && (
                                  <Typography
                                      className="description"
                                      dangerouslySetInnerHTML={{ __html: task.description }}
                                  />
                              )}
                            </>
                        )}
                      </div>
                    </div>
                    </SwipeableTaskCard>
                );
              }
        )}

          </div>

      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
  allUsers: usersSelector(state),
});

const actionCreators = {
  getUsers
};

export default withShipment({ mapStateToProps, actionCreators }, Todo);
